export default "__VITE_ASSET__7rs2dAOm__"